import React from 'react';
import ReactDOM from 'react-dom';
import Scheduler from './js/scheduler';
import './js/string';
import './css/index.css';

ReactDOM.render(
  <Scheduler />,
  document.getElementById('root')
);


// <table class="hi">
// </table>
// <input type="text" name="firstName" value="Peter" />


// window.location = 127.0.0.1:8023/session/#0033
// window.location.pathname = 127.0.0.1:8023/session/
// window.location.hash = #0033
// window.location.hash.substring(1) = 0033



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/